// import SensorDitoImg from "../images/ProductImg/SensorDito.jpg";
// import SensorFogImg from "../images/ProductImg/SensorFog.jpg";
// import SensorFFImg from "../images/ProductImg/SensorFF.jpg";

// export const SensorTopImg = [
//   {
//     id: 1,
//     image: require('../images/ProductImg/SensorTop/FilmSensorPrinciple.png'),
//     alt: 'images/ProductImg/SensorTop/FilmSensorPrinciple.png',
//   },
//   {
//     id: 2,
//     image: require('../images/ProductImg/SensorTop/PCapSensorStructure.png'),
//     alt: 'images/ProductImg/SensorTop/PCapSensorStructure.png',
//   },
//   {
//     id: 3,
//     image: require('../images/ProductImg/SensorTop/FilmSensorStructure.png'),
//     alt: 'images/ProductImg/SensorTop/FilmSensorStructure.png',
//   },
//   {
//     id: 4,
//     image: require('../images/ProductImg/SensorTop/ApplicateConsumer.png'),
//     alt: 'images/ProductImg/SensorTop/ApplicateConsumer.png',
//   },
//   {
//     id: 5,
//     image: require('../images/ProductImg/SensorTop/ApplicateMedical.png'),
//     alt: 'images/ProductImg/SensorTop/ApplicateMedical.png',
//   },
//   {
//     id: 6,
//     image: require('../images/ProductImg/SensorTop/ApplicateIndustrial.png'),
//     alt: 'images/ProductImg/SensorTop/ApplicateIndustrial.png',
//   },
//   {
//     id: 7,
//     image: require('../images/ProductImg/SensorTop/FilmSensorStructure.png'),
//     alt: 'images/ProductImg/SensorTop/FilmSensorStructure.png',
//   },
//   {
//     id: 8,
//     image: require('../images/ProductImg/SensorTop/FilmSensorPrinciple.png'),
//     alt: 'images/ProductImg/SensorTop/FilmSensorPrinciple.png',
//   },
//   {
//     id: 9,
//     image: require('../images/ProductImg/SensorTop/ApplicateConsumer.png'),
//     alt: 'images/ProductImg/SensorTop/PCapTheory.png',
//     // link: 'https://xxxxxx.com/SensorTop/xxxxxx',
//   },
// ]

export const SensorDitoImg = [
  {
    id: 1,
    image: require('../images/ProductImg/SensorDito/DITOTheory.png'),
    alt: 'images/ProductImg/SensorDito/DITOTheory.png',
  },
  {
    id: 2,
    image: require('../images/ProductImg/SensorDito/FogTheory.png'),
    alt: 'images/ProductImg/SensorDito/FogTheory.png',
  },
  {
    id: 3,
    image: require('../images/ProductImg/SensorDito/CofStructure.png'),
    alt: 'images/ProductImg/SensorDito/CofStructure.png',
  },
  {
    id: 4,
    image: require('../images/ProductImg/SensorDito/PCapMultiTouch.png'),
    alt: 'images/ProductImg/SensorDito/PCapMultiTouch.png',
  },
  {
    id: 5,
    image: require('../images/ProductImg/SensorDito/PCapSensorProcess.png'),
    alt: 'images/ProductImg/SensorDito/PCapSensorProcess.png',
  },
  {
    id: 6,
    image: require('../images/ProductImg/SensorDito/PCapApplicate.png'),
    alt: 'images/ProductImg/SensorDito/PCapApplicate.png',
  },
  {
    id: 7,
    image: require('../images/ProductImg/SensorDito/ApplicateConsumer.png'),
    alt: 'images/ProductImg/SensorDito/ApplicateConsumer.png',
  },
  {
    id: 8,
    image: require('../images/ProductImg/SensorDito/ApplicateMedical.png'),
    alt: 'images/ProductImg/SensorDito/ApplicateMedical.png',
  },
  {
    id: 9,
    image: require('../images/ProductImg/SensorDito/SensorOnRack.jpg'),
    alt: 'images/ProductImg/SensorDito/SensorOnRack.png',
  },
  {
    id: 10,
    image: require('../images/ProductImg/SensorDito/SensorExtraSmall.jpg'),
    alt: 'images/ProductImg/SensorDito/SensorExtraSmall.jpg',
  },
  {
    id: 11,
    image: require('../images/ProductImg/SensorDito/SensorSmall.jpg'),
    alt: 'images/ProductImg/SensorDito/SensorSmall.jpg',
  },
  // {
  //   id: 12,
  //   image: require('../images/ProductImg/SensorDito/SensorBySheet.jpg'),
  //   alt: 'images/ProductImg/SensorDito/SensorBySheet.jpg',
  // },
  // {
  //   id: 12,
  //   image: require('../images/ProductImg/SensorDito/-10.jpg'),
  //   alt: 'images/ProductImg/SensorDito/-10.png',
  //   link: 'https://xxxxxx.com/Product/xxxxxx',
  // },
]

export const SensorDitoTxt = [
  // {
  //   id: 0,
  //   image: SensorDitoImg.jpg,
  //   alt: 'images/ProductImg/SensorDitoImg.jpg',
  //   name: 'DITO Glass Sensor',
  //   title: 'DITO Glass 功能片',
  //   link: 'https://www.hlzoptics.com'
  // },
  {
    id: 1,
    // image: require('../images/ProductImg/SensorDito/SensorExtraSmall.jpg'),
    // alt: 'images/ProductImg/SensorDito/SensorExtraSmall.jpg',
    name: 'PCap Dito Sensor Introduce',
    title: '投射电容 Dito Glass 功能片介紹',
    text:
      'PCap Dito 功能片，其内部布满了ITO(氧化铟锡)线路，\n' +
      '是实现触摸感应功能的核心部件，具体如下介绍\n' +
      '  结构组成:\n' +
      '     包含感应、控制层、通讯接口和电源管理模块。感应层由多个感应电极组成，\n' +
      '     用于检出外部、电容变化；控制层含微控制器和驱动电路，负责处理信号；\n' +
      '     通讯接口常见的有I2C、SPI等，用于与其他设备通信；\n' +
      '     电源管理模块则保证稳定供电和优化电源效率\n' +
      '  工作原理：\n' +
      '     功能片通常有两层电极，形成垂直和水平图案轨迹，当手指等\n' +
      '     导电物体接触屏幕，会改变电极间的互电容。控制器通过高频信号\n' +
      '     扫描网格单元，识别电容变化来确定触摸位置\n' +
      '  制作工艺：\n' +
      '     包括ITO开料、ITO老化、丝印银浆、激光蚀刻、印刷绝缘油、\n' +
      '     清洗ITO玻璃片、贴附OCA+ITO等工序，最后经过外观检查、切割、\n' +
      '     擦拭和功能测试等环节，制成成品\n' +
      ' ',
    textEng:
      ' \n',
    describe: 'PCap Dito Sensor Introduce',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    // image: require('../images/ProductImg/SensorDito/SensorSmall.jpg'),
    // alt: 'images/ProductImg/SensorDito/SensorSmall.jpg',
    name: 'PCap Sensor Theory',
    title: '投射电容功能片感应原理(PCap Sensor Theory)',
    text:
      '通过检测电极间电容变化来识别触摸位置，具体过程如下\n' +
      '  电容基线建立:\n' +
      '     功能片的感应电极(行列交叉的ITO网格)会预先形成稳定的电容场，\n' +
      '     控制器会记录初始状态下各电极交叉点的电容值作为基线\n' +
      '  电容值变化检测：\n' +
      '     当手指等导电物体靠近或接触功能片表面时，会干扰电极间的静电场，\n' +
      '     导致对应位置的电容值发生变化(互电容或自电容改变)\n' +
      '  信号处理与定位：\n' +
      '     控制器通过高频信号扫描所有电极交叉点，对比实时电容值与基线的差异，\n' +
      '     算出电容变化的位置坐标\n' +
      '  数据输出：\n' +
      '     将计算出的触摸坐标通过通讯接口(如I2C、SPI)传输给主设备(如处理器)，\n' +
      '     最终实现触摸指令的响应\n' +
      ' ',
    describe: 'PCap Sensor Theory\n',
    link: 'https://www.hlzoptics.com',
    time: '2025/8/1',
  },
  {
    id: 3,
    // image: require('../images/ProductImg/SensorDito/SensorExtraSmall.jpg'),
    // alt: 'images/ProductImg/SensorDito/SensorExtraSmall.jpg',
    name: 'PCap DITO Glass Sensor Structure',
    title: 'DITO Glass 投射电容功能片結構(DITO Glass Sensor Structure)',
    text:
      'DITO Glass功能片结构由玻璃基板、ITO层、电极图案、导电线路、绝缘层、\n' +
      '光学胶和软性电路板组成\n' +
      '  玻璃基板：\n' +
      '     为基础支撑部件，采用玻璃材质，具有良好的透光性和机械强度，\n' +
      '     为整个传感器提供，稳定的物理支撑，确保其在使用过程中保持形状稳定，\n' +
      '     同时不影响光线透过以保证显示效果\n' +
      '  ITO涂层：\n' +
      '     在玻璃基板的正反两面分别镀有氧化铟锡(ITO)涂层，这是一种透明导电材料，\n' +
      '     能够让电流通过，同时不影响玻璃的透光性，为触摸感应提供导电基础\n' +
      '  电极图案：\n' +
      '     玻璃基板两面的ITO涂层通过蚀刻工艺形成相互垂直的电极，\n' +
      '     分别用于检测X与Y轴方向的触摸信号，这些图案多为菱形、矩形等规则形状，\n' +
      '     它们的布局和设计影响着触摸屏的分辨率和灵敏度等性能\n' +
      '  保护层：\n' +
      '     位于传感器的最外层，通常由玻璃或其他耐磨、耐刮材料制成，\n' +
      '     用于保护内部的ITO涂层和电极图案，防止其受到外界的物理损伤，如刮擦、\n' +
      '     碰撞等，同时也能减少灰尘、指纹等对触摸屏表面的污染\n' +
      '  光学胶：\n' +
      '     用于将不同层结构粘合在一起，如将盖板与传感器玻璃基板粘合，\n' +
      '     保证各层之间的贴合紧密，减少空气间隙，从而避免光线折射和反射，\n' +
      '     提高触摸屏的透光率和显示效果\n' +
      '  软性电路板(FPC)：\n' +
      '    连接传感器与控制器，用于传输触摸信号。它具有柔韧性，可以灵活弯曲，\n' +
      '    方便安装在设备内部，将电极检测到的电容变化信号传输给控制器，\n' +
      '    以便进行后续的信号处理和触摸位置计算\n' +
      ' ',
    textEng: ' \n',
    describe: 'PCap DITO Glass Sensor Structure',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 4,
    // image: require('../images/ProductImg/SensorDito/SensorBySheet.jpg'),
    // alt: 'images/ProductImg/SensorDito/SensorBySheet.jpg',
    name: 'Advantages of PCap DITO Sensor(PCap DITO功能片優勢)',
    title: 'PCap DITO Glass功能片优势',
    // title: 'PCap DITO Glass功能片优势(Advantages of PCap DITO Sensor)',
    text:
      '以下优势使其成为现代触摸交互设备中不可或缺的核心部件\n' +
      '  高精度触摸识别：\n' +
      '     通过精细的ITO电极网格和灵敏的电容检测技术，能精准捕捉微小的\n' +
      '     触摸动作，即使是边缘区域或小面积触摸也能准确响应，支持精细操作\n' +
      '  强大的多点触摸支持：\n' +
      '     可同时识别多个触摸点，轻松实现缩放、旋转、滑动等复杂手势，\n' +
      '     满足多样化交互需求\n' +
      '  优异的耐用性：\n' +
      '     蓋板與功能片基材多为强化玻璃，表面硬度高，抗刮擦、耐磨损，\n' +
      '     能承受长期频繁使用，延长设备使用寿命\n' +
      '  良好的环境适应性：\n' +
      '     抗干扰能力强，对灰尘、薄层水滴等表面污染不敏感，在多种环境下\n' +
      '     (如潮湿、多尘)仍能稳定工作\n' +
      '  快速响应速度：\n' +
      '     信号处理效率高，触摸指令从识别到反馈的延迟低，操作流畅无卡顿\n' +
      '  设计灵活性高：\n' +
      '     可根据不同设备需求定制尺寸、形状和电极图案，适配手机、平板、\n' +
      '     工业面板、车载屏幕等多种产品\n' +
      ' ',
    describe: 'PCap Sensor Theory\n',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 5,
    // image: require('../images/ProductImg/SensorDito.jpg'),
    // image: SensorDitoImg,
    name: 'Multi-touch(多點觸控)',
    title: 'PCap 功能片多點觸控(PCap Sensor Multi-touch)',
    text:
      'PCap 多点触控技术精准协同交互体验，支持复杂触控场景：\n' +
      '  多触控点识别：\n' +
      '     支持10点及以上同步识别(依方案适配)，精准捕捉多指操作轨迹，\n' +
      '     告别单点交互局限。\n' +
      '     在一些大型会议展示场景中，多人可以同时在大屏上进行操作，\n' +
      '     系统能够清晰分辨每个人的触摸点，实现数据对比展示、\n' +
      '     多人实时批注等功能，有效提升会议效率\n' +
      '  手势智能解析：\n' +
      '     覆盖旋转(图片360°调控)、缩放(无级缩放)、双指滑动(快速切屏/分屏)、\n' +
      '     多指唤起(自定义指令)等复合手势，适配消费电子、工控、\n' +
      '     医疗等场景交互逻辑。\n' +
      '     比如在建筑设计领域，设计师利用双指缩放3D建筑模型，切换展示不同楼层，\n' +
      '     通过三指旋转模型，从各个角度观察建筑外观与内部结构，\n' +
      '     配合多指唤起快捷指令，快速调出尺寸标注、材质信息等，\n' +
      '     大幅提高设计构思与方案展示效率\n' +
      '  抗干扰算法：\n' +
      '     内置抗噪过滤、误触抑制机制，戴手套/水痕/油污环境，能识别有效触控，\n' +
      '     确保工业级、医疗级设备，可靠性\n' +
      '     在石油化工业生产，需戴着手套操作设备，即便手套上沾有油污，\n' +
      '     搭载PCap的工控触摸屏能精准操作，\n' +
      '     在医疗手术室，即使双手存在水痕，触摸医疗设备时，透过抗干扰算法确保\n' +
      '     操作能被准确识别，保障手术进程顺利进行\n' +
      '  全场景适配：\n' +
      '     从消费级手机(2~10”小屏)到商显大屏(27~65”)，跨尺寸覆盖多指、\n' +
      '     多人协同操作，重塑触控交互效率。在课堂上师生在教学屏上同时书写、\n' +
      '     擦除操作，老师的操作可以同时展示在学生的平板上，实现互动教学；\n' +
      '     在零售行业，消费者在互动大屏上双指缩放商品图片查看细节，\n' +
      '     多指滑动切换商品类别，提高购物体验\n' +
      ' ',
    describe: 'Multi-touch capability\n' +
      'Longevity\n' +
      'Adjustable sensitivity\n' +
      'Integrated solutions\n' +
      'Durability and reliability\n' +
      'Customisable and intuitive\n' +
      'Image clarity\n',
    // text: 'PCap sensor enables input through multiple touch points, lines and gestures',
    link: 'https://www.hlzoptics.com',
    time: '2025/8/5',
  },
  {
    id: 6,
    image: require('../images/ProductImg/SensorDito/CofStructure.png'),
    alt: 'images/ProductImg/SensorDito/CofStructure.png',
    name: 'DITO Glass Sensor Size(DITO Glass功能片尺寸)',
    title: 'PCap DITO Glass 玻璃功能片尺寸(DITO Glass Sensor Size)',
    text:
      'DITO Glass Sensor尺寸方案适配不同应用，覆盖消费、工控、医疗等领域，\n' +
      '依据可视区域与玻璃厚度\n' +
      '  消费类：\n' +
      '     Typical 2~10”，玻璃厚度G0.4~G1.1mmt，适配手机、平板等小型消费电子，\n' +
      '     轻薄灵敏，贴合便携需求\n' +
      '  人机介面：\n' +
      '     Typical 7~12”，玻璃厚度G0.55~G1.8mmt，覆盖智能交互终端、车载中控等，\n' +
      '     平衡触感与耐用性\n' +
      '  工业控制：：\n' +
      '     Typical 14~18”，玻璃厚度G1.1~G2.0mmt，适配工业触摸屏、自助终端，\n' +
      '     满足复杂工况下的抗冲击、高稳定需求\n' +
      '  医疗类：\n' +
      '     Typical 4~20”，玻璃厚度G0.55~G2.0mmt，覆盖医疗设备触摸屏\n' +
      '     (如监护仪、诊断终端)，兼顾卫生易清洁与精准触控\n' +
      '  AIO(一体机)：\n' +
      '     Typical 15~23”，玻璃厚度G1.1~G3.0mmt，适配一体机电脑、智能会议屏，\n' +
      '     支撑大尺寸高清触控体验\n' +
      '  超大尺寸：\n' +
      '     Typical 27~65”，玻璃厚度G1.1~G3.0mmt ，覆盖商显大屏、数字标牌等，\n' +
      '     实现大尺寸场景下稳定多点触控\n' +
      ' ',
    describe: 'DITO PCap觸控功能片從小尺寸到大尺寸都有全面的解決方案，並具有最大的優勢',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 7,
    // image: require('../images/ProductImg/SensorDito.jpg'),
    // image: SensorDitoImg,
    name: 'HLZ currently developed sizes(HLZ 現已開發的尺寸)',
    title: 'HLZ PCap Dito Glass 功能片現已開發的尺寸',
    engtitle: 'HLZ PCap Sensor currently developed sizes',
    text:
      '\n' +
      '  小小尺寸：\n' +
      '     2吋/30款、3吋/50款、4吋/78款\n' +
      '  小尺寸：\n' +
      '     5吋/120款、6吋/12款、7吋/260款\n' +
      '  小中尺寸：\n' +
      '     8吋/130款、9吋/30款、10吋/300款\n' +
      '  中尺寸：\n' +
      '     11吋/20款、12吋/90款、13吋/60款、14吋/15款\n' +
      '  中大尺寸：\n' +
      '     15吋/100款、17吋/20款、18吋/20款、19吋/20款\n' +
      '  大尺寸：\n' +
      '     21吋/60款、23吋/30款、27吋/15款、32吋/15款\n' +
      '  超大尺寸：\n' +
      '     43吋/2款、46吋/1款、49吋/15款、55-65吋/1款\n' +
      ' ',
    describe: 'HLZ currently developed sizes',
    link: 'https://www.hlzoptics.com',
    time: '2025/8/5',
  },
  {
    id: 8,
    // image: require('../images/ProductImg/SensorDito.jpg'),
    // image: SensorDitoImg,
    name: '场景化价值延伸',
    title: '场景化价值延伸',
    text:
      '\n' +
      '  医疗场景：\n' +
      '     数字化阅片终端上，医生通过双指缩放CT影像，精准定位毫米级病灶；\n' +
      '     三指滑动快速切换不同序列切片，结合多指旋转功能，全方位观察肿瘤形态，\n' +
      '     提升诊断效率与准确性。\n' +
      '     在脑部肿瘤诊断中，通过旋转从多个角度观察肿瘤与周围神经、血管的关系，\n' +
      '     为手术方案制定提供更精准依据\n' +
      '  工控场景：\n' +
      '     工业一体机操作中，工人可多指拖拽3D机械模型，模拟装配流程；\n' +
      '     双指旋转查看设备内部结构，配合三指唤起快捷参数面板，缩短调试周期，\n' +
      '     降低操作失误率。\n' +
      '     在汽车制造工厂，调试汽车零部件装配时，利用这些功能快速验证装配方案，\n' +
      '     减少因操作失误导致的设备损耗和时间浪费\n' +
      '  消费场景：\n' +
      '     绘画应用里，支持6点同步压感识别，画家可双指缩放画布、多指切换笔刷，\n' +
      '     还原真实手绘的细腻笔触；多人协同游戏时，多玩家同步触控操作无延迟，\n' +
      '     强化互动体验。像热门的多人合作解谜游戏，玩家可以同时在屏幕上点击、\n' +
      '     滑动、缩放地图，共同完成任务，提升游戏乐趣\n' +
      '  商显场景：\n' +
      '     智能会议大屏中，多人可同时双指缩放各自区域内容，四指唤起分屏书写，\n' +
      '     实现跨部门方案实时批注，打破传统单屏交互的效率壁垒。\n' +
      '     如在广告策划会议上，不同部门可在同一屏幕上针对广告方案各自操作，\n' +
      '     提出修改意见，快速迭代方案\n' +
      ' ',
    describe: '场景化价值延伸\n' +
      '\n',
    // text: 'PCap sensor enables input through multiple touch points, lines and gestures',
    link: 'https://www.hlzoptics.com',
    time: '2025/8/5',
  },
]

export const SensorFFImg = [
  {
    id: 1,
    image: require('../images/ProductImg/SensorFF/FilmSensor.png'),
    alt: 'images/ProductImg/SensorFF/FilmSensor.png',
  },
  {
    id: 4,
    image: require('../images/ProductImg/SensorFF/FilmSensorTheory.png'),
    alt: 'images/ProductImg/SensorFF/FilmSensorTheory.png',
  },
  {
    id: 3,
    image: require('../images/ProductImg/SensorFF/FilmSensorPrinciple.png'),
    alt: 'images/ProductImg/SensorFF/FilmSensorPrinciple.png',
  },
  {
    id: 2,
    image: require('../images/ProductImg/SensorFF/FilmSensorStructure.png'),
    alt: 'images/ProductImg/SensorFF/FilmSensorStructure.png',
  },
  {
    id: 2,
    image: require('../images/ProductImg/SensorFF/MultiTouch.png'),
    alt: 'images/ProductImg/SensorFF/MultiTouch.png',
  },
  {
    id: 6,
    image: require('../images/ProductImg/SensorFF/PCapApplicate.png'),
    alt: 'images/ProductImg/SensorFF/PCapApplicate.png',
    // link: 'https://xxxxxx.com/Product/xxxxxx',
  },
]

export const SensorFFTxt = [
  // {
  //   id: 0,
  //   image: SensorFFImg.jpg,
  //   alt: 'images/ProductImg/SensorDitoImg.jpg',
  //   name: 'DITO Glass Sensor',
  //   title: 'DITO Glass 功能片',
  //   link: 'https://www.hlzoptics.com'
  // },
  {
    id: 1,
    // image: require('../images/ProductImg/SensorFF/FilmSensor.png'),
    // alt: 'images/ProductImg/SensorFF/FilmSensor.png',
    // image: SensorFFImg,
    // alt: 'images/ProductImg/SensorFF.jpg',
    name: 'Film Sensor Introduce(Film/Film功能片介紹)：',
    title: 'Film 功能片原理介绍',
    text:
      'Film Sensor，即基于软性薄膜的电容式触摸功能片原理介绍：\n' +
      '  工作原理\n' +
      '     Film Sensor 基于电容式触摸原理，具体流程如下：\n' +
      '     ＊电容耦合形成\n' +
      '         上下导电层分别作为发射极(Tx)和接收极(Rx)，通过绝缘层形成平行板电容\n' +
      '         当手指(导电体)靠近或触摸屏时，手指与导电层之间形成附加电容，\n' +
      '         导致原电容值发生变化\n' +
      '     ＊信号检测与定位\n' +
      '         控制器向X轴电极发送交变电压，Y轴电极接收电流信号，触摸时，\n' +
      '         电容变化会引起电流波动，控制器通过扫描X-Y电极矩阵，\n' +
      '         计算出电容变化的坐标位置，实现触摸定位\n' +
      '     ＊多点触控支持\n' +
      '         由于上下电极层独立，功能片可同时检测多个触摸点的电容变化，\n' +
      '         支持多点触控(如双指缩放、三指滑动等)\n' +
      ' ',
    describe: 'Base customer require, We support ff sensor design and development GFF touch panel',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    // image: require('../images/ProductImg/SensorFF/FilmSensor.png'),
    // alt: 'images/ProductImg/SensorFF/FilmSensor.png',
    // image: SensorFFImg,
    // alt: 'images/ProductImg/SensorFF.jpg',
    name: 'Film Sensor Structure(Film/Film功能片结构)：',
    title: 'Film 功能片结构',
    text:
      'Film Sensor，即基于软性薄膜的电容式触摸功能片，从结构、原理、\n' +
      ' 特点及应用展开介绍：\n' +
      '  结构组成\n' +
      '     Film Sensor以软性薄膜(PET)为基底，通过多层复合结构实现触摸感应，\n' +
      '     核心组成如下：\n' +
      '     ＊柔性基底(PET薄膜)\n' +
      '         材质轻薄柔韧，厚度通常为 50-200μm，可弯曲折叠，适应曲面屏幕或\n' +
      '         异形设备设计。透光率高(≥90%)，确保屏幕显示效果不受影响\n' +
      '     ＊透明导电层(ITO或替代材料)\n' +
      '         在上下两层PET薄膜上分别镀覆ITO或其他导电材料(如银纳米线、\n' +
      '         石墨烯)，形成X轴和Y轴电极层电极图案通过光刻工艺制成，\n' +
      '         常见形状为菱形、网格状或条纹状，间距和密度决定触摸分辨率\n' +
      '     ＊绝缘层(Dielectric Layer)\n' +
      '         位于上下导电层之间，为PET或光刻胶材质，厚度1-5μm，\n' +
      '         防止上下电极短路，并形成电容耦合空间\n' +
      '     ＊保护层(Hard Coat/OC层)\n' +
      '         上层PET外侧覆盖Hard Coat，硬度可达3H-4H，抗刮擦、防指纹；\n' +
      '         部分产品涂布防眩光(AG)或防油渍(AF)层\n' +
      '     ＊软性电路板(FPC)\n' +
      '         连接电极层与主控芯片，通常焊接在传感器边缘，传输触摸信号\n' +
      ' ',
    describe: ' ',
    // link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 3,
    // image: require('../images/ProductImg/SensorFF/FilmSensorStructure.png'),
    // alt: 'images/ProductImg/SensorFF/FilmSensorStructure.png',
    // image: SensorFFImg,
    // alt: 'images/ProductImg/SensorFF.jpg',
    name: 'Film Sensor Size(Film 功能片尺寸)：',
    title: 'Film Sensor Size(功能片尺寸)',
    text:
      'Film Touch Sensor适用不同应用场景，包刮消费、工控、医疗等领域，\n' +
      ' 依据VA(可视区域)尺寸：\n' +
      '  消费类：\n' +
      '     Typical 2~10”，膜厚度FF0.25、FF0.425、FF0.5mmt，适配手机、\n' +
      '     平板等小型消费电子，轻薄灵敏，贴合便携需求\n' +
      '  人机介面：\n' +
      '     Typical 7~12”，膜厚度FF0.25、FF0.425、FF0.5mmt，覆盖智能交互终端、\n' +
      '     车载中控等，平衡触感与耐用性\n' +
      '  工业控制：：\n' +
      '     Typical 14~18”，玻璃厚度G1.1~G2.0mmt，适配工业触摸屏、自助终端，\n' +
      '     满足复杂工况下的抗冲击、高稳定需求\n' +
      '  医疗类：\n' +
      '     Typical 4~20”，玻璃厚度G0.55~G2.0mmt，覆盖医疗设备触摸屏\n' +
      '     (如监护仪、诊断终端)，兼顾卫生易清洁与精准触控\n' +
      '  AIO(一体机)：\n' +
      '     Typical 15~23”，玻璃厚度G1.1~G3.0mmt，适配一体机电脑、智能会议屏，\n' +
      '     支撑大尺寸高清触控体验\n' +
      '  超大尺寸：\n' +
      '     Typical 27~65”，玻璃厚度G1.1~G3.0mmt，覆盖商显大屏、数字标牌等，\n' +
      '     实现大尺寸场景下稳定的多点触控\n' +
      ' ',

    // text: '\n' +
    //   '   2~10吋/消費類/FF0.25、FF0.425、FF0.5mmt\n' +
    //   '   7~12吋/人機介面/ FF0.25、FF0.425、FF0.5mmt\n' +
    //   '   14~18吋/工业控制類/ FF0.25、FF0.425、FF0.5mmt\n' +
    //   '   4~20吋醫療類/ FF0.25、FF0.425、FF0.5mmt\n' +
    // ' ',
    describe: 'XXXXX Base customer require, We support ff sensor design and development GFF touch panel',
    link: 'https://www.hlzoptics.com',
    time: '2025/8/6',
  },
  {
    id: 4,
    image: require('../images/ProductImg/SensorFF/FilmSensorPrinciple.png'),
    alt: 'images/ProductImg/SensorFF/FilmSensorPrinciple.png',
    // image: SensorFFImg,
    // alt: 'images/ProductImg/SensorFF.jpg',
    name: 'Advantages of PCap Film Sensor',
    title: 'PCap 薄膜功能片优势',
    text: '\n' +
      '  高精度触摸识别\n' +
      '     通过精细的ITO电极网格和灵敏的电容检测技术，能精准捕捉微小的触摸动作，\n' +
      '  强大的多点触摸支持：\n' +
      '     可同时识别多个触摸点，轻松实现缩放、旋转、滑动等复杂手势，\n' +
      '     满足多样化交互需求\n' +
      '  优异的耐用性：\n' +
      '     蓋板，表面硬度高，抗刮擦、耐磨损，能承受长期频繁使用，\n' +
      '     延长设备使用寿命\n' +
      '  良好的环境适应性：\n' +
      '     抗干扰能力强，对灰尘、薄层水滴等表面污染不敏感，在多种环境下\n' +
      '     (如潮湿、多尘)仍能稳定工作\n' +
      '  快速响应速度：\n' +
      '     信号处理效率高，触摸指令从识别到反馈的延迟低，操作流畅无卡顿\n' +
      '  设计灵活性高：\n' +
      '     可根据不同设备需求定制尺寸、形状和电极图案，适配手机、平板、\n' +
      '     工业面板、车载屏幕等多种产品\n' +
      '  易加工....\n' +
      '  超薄....\n' +
      ' ',
    describe: 'FilmFilm PCap觸控功能片從小尺寸到大尺寸都有全面的解決方案，並具有最大的優勢',
  },
  // {
  //   id: 4,
  //   image: require('../images/ProductImg/SensorFF.jpgg'),
  //   image: SensorFFImg,
  //   alt: 'images/ProductImg/SensorFF.jpg',
  //   name: 'Film Film Sensor Structure',
  //   title: 'Film Film 功能片結構',
  //   text: 
  //     ' • 雙層薄膜\n' +
  //     ' • 上下層ITO膜使用方阻為60~120Ω/sq PET薄膜\n' +
  //     ' • 周邊使用銀或黃光製程Mo/Al導線連接FPC\n' +
  //     ' • 銀導線pitch 0.8mm，金屬導線可達xxum\n' +
  //     ' • 金屬導線導電性與可鬧竟均遠高於銀道線\n' +
  //     ' • ITO trace 採用刨光顯影製程',
  //   describe: '',
  //   link: 'https://www.hlzoptics.com',
  //   time: '2025/1/4',
  // }
]

export const SensorFogImg = [
  {
    id: 1,
    image: require('../images/ProductImg/SensorFog/FogTheory.png'),
    alt: 'images/ProductImg/SensorFog/FogTheory.png',
  },
  {
    id: 2,
    image: require('../images/ProductImg/SensorFog/CofFogStructureB.png'),
    alt: 'images/ProductImg/SensorFog/CofFogStructureB.png',
  },
  {
    id: 3,
    image: require('../images/ProductImg/SensorFog/CofFogStructureC.png'),
    alt: 'images/ProductImg/SensorFog/CofFogStructureC.png',
  },
  {
    id: 4,
    image: require('../images/ProductImg/SensorFog/FogApplicate.jpg'),
    alt: 'images/ProductImg/SensorFog/FogApplicate.jpg',
  },
  // {
  //   id: 5,
  //   image: require('../images/ProductImg/SensorFog/-5.jpg'),
  //   alt: 'images/ProductImg/SensorFog/Fog-5.png',
  // },
  // {
  //   id: 6,
  //   image: require('../images/ProductImg/SensorFog/-6.jpg'),
  //   alt: 'images/ProductImg/SensorFog/Fog-6.png',
  //   // link: 'https://xxxxxx.com/Product/xxxxxx',
  // },
]

export const SensorFogTxt = [
  // {
  //   id: 0,
  //   image: SensorFogImg.jpg,
  //   alt: 'images/ProductImg/SensorFogImg.jpg',
  //   name: 'Fog Glass Sensor',
  //   title: 'Fog Glass 功能片',
  //   link: 'https://www.hlzoptics.com'
  // },
  {
    id: 1,
    image: require('../images/ProductImg/SensorFF/FilmSensorPrinciple.png'),
    alt: 'images/ProductImg/SensorFF/-3',
    // image: SensorFogImg,
    // alt: 'images/ProductImg/SensorFog.jpg',
    name: 'Sensor+FPC(COB type) with Contoller',
    title: '功能片 Bonding FPC 接控制卡(COB type Connect IC Controller)',
    text:
      '通过一体化设计与标准化工艺，Sensor+FPCA方案正成为消费电子功能片\n' +
      ' 集成的主流选择之一，尤其适合对生产效率与可靠性要求较高的客户\n' +
      '  一体化结构设计：\n' +
      '     采用玻璃或薄膜功能片与FPC直接热压键合的 COB(Chip on Board)集成工艺，\n' +
      '     将Sensor与FPC完美结合为一个整体单元出货\n' +
      '  专业热压工艺保障可靠性：\n' +
      '     产品在出厂前通过专业设备完成热压键合，热压参数严格控制在温180±5℃、\n' +
      '     压力3~5kgf/cm²、时间15~20s范围内。相比客户自行热压，专业工艺可\n' +
      '     使键合强度提升20%，且FPC与Sensor的贴合精度误差控制在±10μm以内。\n' +
      '     同时热压界面采用ACF(异向导电胶)，其导电粒子密度达到1000~2000个/mm²，\n' +
      '     确保信号传输稳定可靠，极大提升了产品的耐弯折性(弯折寿命≥10万次)与\n' +
      '     抗振动/抗冲击能力(随机振动10~2000Hz，2g，2 小时无异常)\n' +
      '  质量管控与功能测试：\n' +
      '     ＊基本性能测试\n' +
      '     ＊环境适应性测试\n' +
      '     ＊可靠性测试\n' +
      '  專業熱壓對產品的可靠性獲得極大的提升\n' +
      '     ＸＸＸＸＸＸ ？？？\n' +
      '  控制器选型与应用适配\n' +
      '     ＊控制器選用EETI、Ilitek、WeiDa 等知名廠商的IC\n' +
      '     ＊使用控制器一般應用於通道數較多大尺寸產品\n',
    // '    XXXXXX 质量管控与功能测试：\n' +
    // '     XXXXXX 采用玻璃或薄膜功能片与FPC直接热压键合的 COB(Chip on Board)集成工艺，\n' +
    // '    XXXXXX 质量管控与功能测试：\n' +
    // '     XXXXXX 采用玻璃或薄膜功能片与FPC直接热压键合的 COB(Chip on Board)\n' +
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 2,
    image: SensorFogImg,
    alt: 'images/ProductImg/SensorFog.jpg',
    name: 'Sensor+FPCA(COF type)',
    title: '功能片 Bonding FPCA(COF type)',
    text:
      'Sensor+FPCA(Chip on Film)是将功能片(Glass或Film材质)与软性电路板(FPC)\n' +
      ' 通过特定工艺键合为一体化组件的技术方案\n' +
      '  COF封装形式：芯片直接贴装在软性基板(Film)上\n' +
      '  一体化出货模式：传感器与FPC预先完成键合、测试\n' +
      '  技术优势与客户价值\n' +
      '     ＊省去热压工序，降低生产门槛\n' +
      '     ＊传统方案中，客户需自行采购传感器与FPC并通过热压工艺贴合\n' +
      '     ＊一体化方案直接提供成品组件，客户可跳过复杂热压环节，\n' +
      '         减少设备投入与工艺调试成本，缩短产品开发周期\n' +
      '  专业热压提升可靠性\n' +
      '     ＸＸＸＸＸＸ ？？？\n' +
      '  由供应商采用标准化热压工艺(如ACF热压、热超声键合等)，控制温度、压力、\n' +
      '     时间等参数，确保键合强度、导电性及耐弯折性\n' +
      '  全功能测试保障品质\n' +
      '     ＊出货前完成电气性能测试、功能测试 及环境可靠性测试\n' +
      '     ＊有效拦截开路、短路、功能失效等不良品，避免客户产线因来料问题\n' +
      '         导致的良率损失\n' +
      '  核心供应链与IC厂商\n' +
      '     ＸＸＸＸＸＸ ？？？\n' +
      '  技术趋势与建议\n' +
      '     ＊技术升级方向：向更高密度键合(如倒装焊技术)、超薄柔性基板\n' +
      '         (厚度＜50μm)发展，适配折叠屏、可卷曲设备\n' +
      '     ＊客户选型建议：若产品需小尺寸、高可靠性及快速量产，\n' +
      '         优先考虑 Sensor+FPCA方案，同时关注IC厂商的技术支持与\n' +
      '         供应链稳定性(如FocalTech、Goodix在手机领域的成熟案例)\n' +
      ' ',
    link: 'https://www.hlzoptics.com'
  },
  // {
  //   id: 3,
  //   image: SensorFogImg,
  //   alt: 'images/ProductImg/SensorFog.jpg',
  //   name: 'COF Sensor with FPCA',
  //   title: 'Sensor+FPCA(COF type)',
  //   text:
  //     'Glass或是FF功能片與 FPCA 連接成一個整體出貨\n' +
  //     '客戶省去熱壓工序\n' +
  //     '專業熱壓對產品的可靠性獲得極大的提升\n' +
  //     'Control IC: FocalTech、Goodix、EETI、Ilitek\n' +
  //     '                   WeiDa... 等知名廠商 IC\n' +
  //     '使用 FPCA 方式多用於小尺寸消費等種類\n',
  //   link: 'https://www.hlzoptics.com'
  // }
]